// extracted by mini-css-extract-plugin
export default {"tableRow":"chainSettingsRow__tableRow___mq8nY","actions":"chainSettingsRow__actions___Nb7Bt"};